import React from "react";
import getIconSVG from "./getIconSVG";

function Icon({ name }) {
  return <img alt={name} src={getIconSVG(name).src} />;
}

export default Icon;
